import Constants from '../constants'
import axios from 'axios'
import router from "../router";

const state = {
    loading: false,
    user: null,
    error: null,
    loginAttempts: 0,
    isLoggedIn: !!localStorage.getItem(Constants.accessToken)
};

const getters =  {
    user(state) {
        return state.user;
    },
    userDisplayName(state) {
        if (state.user.name && state.user.surname)
            return state.user.name + ' ' + state.user.surname
        return ''
    },
    loading(state) {
        return state.loading;
    },
    error(state) {
        return state.error;
    },
    loginAttempts(state) {
        return state.loginAttempts
    },
    isLoggedIn(state) {
        return state.isLoggedIn;
    }
}


const mutations = {
    setUser(state, payload) {
        state.user = payload;
    },
    setLoading(state, payload) {
        state.loading = payload;
    },
    setError(state, payload) {
        state.error = payload;
    },
    clearError(state) {
        state.error=null;
    },
    incrementLoginAttempts(state) {
        state.loginAttempts += 1;
    },
    resetLoginAttempts(state) {
        state.loginAttempts = 0;
    },
    setIsLoggedIn(state, payload) {
        state.isLoggedIn = payload;
    }
}

const actions = {

    signUserIn({commit}, payload) {
        commit('setLoading', true);
        commit('clearError');

        axios.post(Constants.apiBaseURL+'users/dashboard-login', {
            email: payload.email,
            password: payload.password
        })
            .then(response => {
                commit('setLoading', false);
                let responseData = response['data']['data'][0];
                const newUser = {
                    id: responseData.user.id,
                    name: responseData.user.first_name,
                    surname: responseData.user.last_name
                }
                localStorage.setItem(Constants.accessToken, responseData.token)
                commit('setUser', newUser)
                commit('setIsLoggedIn', true)
                commit('resetLoginAttempts')
            })
            .catch(error => {
                commit('setLoading', false);
                commit('setError', error);
                commit('incrementLoginAttempts')
            });
    },

    autoSignIn({commit}) {
        axios.get(Constants.apiBaseURL+'users/account-information', {})
            .then(response => {
                let responseData = response['data']['data'][0];
                const newUser = {
                    id: responseData.id,
                    name: responseData.first_name,
                    surname: responseData.last_name
                }
                commit('setUser', newUser)
            })
            .catch(() => {
            });
    },

    logout({commit}) {
        axios.post(Constants.apiBaseURL+'users/logout', {})
            .then(()=> {
                localStorage.removeItem(Constants.accessToken);
                commit('setIsLoggedIn', false)
                commit('setUser', null)
                commit('resetLoginAttempts')
                router.push('/signin')
            })
            .catch(() => {
                localStorage.removeItem(Constants.accessToken);
                commit('setIsLoggedIn', false)
                commit('setUser', null)
                commit('resetLoginAttempts')
                router.push('/signin');
            });
    },

    clearError({commit}) {
        commit('clearError');
    },
}

export default {
    namespaced: true,
    state,
    getters, 
    mutations,
    actions
}

